import { useMemo } from "react";
import { ListUserDto } from "../models/user.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredUsers(users: ListUserDto[]) {
	const { query } = useSearch();

	const filteredUsers = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return users?.filter(user =>
				(user.Name && user.Name.toLowerCase().includes(lowerQuery))) || [];
		} else {
			return users || [];
		}
	}, [query, users]);

	return { filteredUsers, showNoResults: query && query.length > 0 && filteredUsers.length === 0 };
}